
import Store from '../store/Store'
import StringHelpers from '../helpers/StringHelpers'
import NumberHelpers from './NumberHelpers';


export default class {

    static loanElement() {
        
        let loanElement = Store.getters.elements.find(o => o.widget == 'Loan Diagram')
        if(!loanElement)
            loanElement = {
                diagram: [
                    {loans: [], properties: []}
                ]
            }
        return loanElement
    }

    static allLoans() {
        
        let loans = []

        let groups = this.loanDiagram()
        groups.forEach(group => {
            loans = [...loans, ...group.loans]
        })
        return loans    
    }

    static newMoney() {
        let total = 0
        this.allLoans.forEach(loan => {
            let amt = loan.newMoney

            if(!amt) {
                amt = loan.amount
                if(loan.lmiType == 'Capitalised')
                    amt += loan.lmi
            }
            total += amt
        })
        return total
    }

    static allProperties() {
        let properties = []
        this.loanDiagram().forEach(group => {
            properties = [...properties, ...group.properties]
        })
        return properties
    }

    static anyFixedLoans() {
        return Boolean(this.allLoans().find(o => o.fixed > 0))
    }

    static anyioLoans() {
        return Boolean(this.allLoans().find(o => o.io > 0))
    }

    static anyLMI() {
        return Boolean(this.allLoans().find(o => o.lmiType == 'Capitalised' || o.lmiType == 'Included'))
    }

    static anyOwnerOccupied() {
        return Boolean(this.allProperties().find(o => !o.investment))
    }

    static anyInvestmentProperties() {
        return Boolean(this.allProperties().find(o => o.investment))
    }

    static totalLending () {
        return this.allLoans().reduce(function(a, b) {
            return a + b.amount
        }, 0)
    }

    // static loanFields() {
    //     let arr = []
    //     arr.push({
    //         name:'loan_count', 
    //         value: this.allLoans().length
    //     })
    //     arr.push({
    //         name:'property_count', 
    //         value: this.allProperties().length
    //     })
    //     arr.push({
    //         name:'fixed_lending', 
    //         value: this.anyFixedLoans()
    //     })
    //     arr.push({
    //         name:'io_lending', 
    //         value: this.anyioLoans()
    //     })
    //     arr.push({
    //         name:'total_lending', 
    //         value: this.totalLending()
    //     })
    //     return arr
    // }



    static diagramDetails(diagramData) {
        return diagramData.map(group => {
            let returnGroup = {
                propertyTotal: group.properties.map( o => o.value)
                    .reduce((a,b) => {return a + b}),

                loanTotal: group.loans.map( o => o.amount)
                    .reduce((a,b) => {return a + b}),
            }
            
            let returnLoans = group.loans.map( loan => {
                    
                return {
                    ...loan,
                    meta: {
                        width: Math.round(loan.amount / returnGroup.propertyTotal * 10000) / 100,
                        get title() {
                            let result = this.amountDescription
                            if(loan.rate)
                                result += ' @ ' + loan.rate.toString() + '%'
                            if(loan.years && loan.years < 30)
                                result += ' over ' + loan.years.toString() + 'yrs'
                            return result
                        },
                        get description() {
                            let result = ''
                            // result += loan.newMoney ? ' New:' + NumberHelpers.abbreviateNumber(loan.newMoney) + '\n' : ''
                            result += loan.newMoney ? ' New:' + NumberHelpers.abbreviateNumber(loan.newMoney) : ''
                            result += loan.investment ? ' Investment' : ' Owner occupied'
                            result += loan.fixed ? ` ${loan.fixed}y fixed` : ' variable'
                            result += loan.rateLock ? ` RATE LOCK` : ''
                            result += (loan.io ? `, ${loan.io}y IO` : ', P&I')
                            result += loan.product ? ` - ${loan.product}` : ''
                            if(!loan.years || loan.years == 30)
                                result += ' over 30 years'

                            return result
                        },
                        get amountTotal() {
                            if(!loan.lmi || loan.lmiType == 'Included')
                                return loan.amount
                            
                            return loan.amount + loan.lmi
                        },

                        get amountBase() {
                            if(!loan.lmi || loan.lmiType == 'Capitalised')
                                return loan.amount
                            
                            return loan.amount - loan.lmi
                        },

                        get amountDescription() {
                            let result = StringHelpers.formatCurrency(this.amountTotal)
                            if (loan.lmi) {
                                result += ' (' + NumberHelpers.abbreviateNumber(this.amountBase) + ' + ' +
                                NumberHelpers.abbreviateNumber(loan.lmi) + ' lmi)'
                            }
                            return result
                        }
                    }
                }
            })

            let returnProperties = group.properties.map( property => {
                    
                return {
                    ...property,
                    meta: {
                        width: Math.round(property.value / returnGroup.propertyTotal * 10000) / 100,
                        get description() {
                            let result = ''
                            if(property.address)
                                result += property.address
                            if(property.investment)
                                result += ' (INV)'
                            else
                                result += ' (HOME)'
                            if(property.existing)
                                result += ' (EXISTING)'
                            return result
                        }
                    }                            
                }
            })
            
            returnGroup.loans = returnLoans
            returnGroup.properties = returnProperties
            returnGroup.lvr = Math.round(returnGroup.loanTotal / returnGroup.propertyTotal * 10000) / 100

            return returnGroup
            
        })
    }

    static diagramDescription(diagramData) {
    
        let html = ''
        diagramData.forEach( (group, groupIndex) => {
            if(diagramData.length > 1) 
                html += `<b><u>Transaction ${groupIndex + 1}</u></b><br/>`
            group.loans.forEach((loan, loanIndex) => {
                html += `<b>${loan.meta.title}</b><br/>`
                html += `- ${loan.meta.description}`
                if(loan.product)
                    html += ` | ${loan.product}`
                html += '<br/>'
            })
            html += '<b>Security</b><br/>'
            group.properties.forEach( (property, index) => {
                html += StringHelpers.formatCurrency(property.value) 
                if(property.address) 
                    html += ' - ' + property.address
                html += '&nbsp;(' + (property.investment ? 'INV' : 'OO') + (property.existing ? '/EXISTING' : '') + ')'
                html += '<br/>'
            })
            html += '<br/>'
        })
        
        html = html.wrap('<div>', '</div>')
        return html
    }

    static diagramPicture(diagramData) {
        let html = ''
        diagramData.forEach( (group) => {
            html += '<div style="margin:2px 0px;border:dotted 3px #ddd;border-radius:8px"><table style="width:100%"><tr>'
            group.loans.forEach((loan) => {
                html += `<td style="${this.generateLoanStyle(loan)}" 
                    title="${loan.meta.title} | ${loan.meta.description}">
                    ${NumberHelpers.abbreviateNumber(loan.meta.amountTotal)}</td>`
            })
   
            //lvr display
            html += '<td style="border:solid 2px white;padding:4px 6px;width:'+ (100 - group.lvr) + ';border-radius:7px;%">' + group.lvr + '%</td>'
            
            html += '</tr></table><table style="width:100%"><tr>'
            group.properties.forEach( (property) => {
                html += `<td style="${this.generatPropertyStyle(property)}" title="${property.meta.description}">
                    ${NumberHelpers.abbreviateNumber(property.value)} 
                    </td>`
            })
      
            html += '</tr></table></div>'
        })
        
        html = html.wrap('<div style="max-width:400px;">', '</div>')
        return html
    }  
    
    static generateLoanStyle(loan) {
        let style = 'border:solid 2px white;color:white;padding:4px 6px;border-radius:7px;'
        if(loan.investment)
            style += 'background-color:#5c6bc0;'
        else
            style += 'background-color:#42a5f5;'
        style += "width:" + loan.meta.width + '%;'
        return style
    }
    static generatPropertyStyle(property) {
        let style = 'border: solid 2px white;color:white;padding:4px 6px;border-radius:7px;'
        if(property.investment)
            style += 'background-color:#ef6c00;'
        else
            style += 'background-color:#ff9800;'
        style += "width:" + property.meta.width + '%;'
        return style
    }
}


// WEBPACK FOOTER //
// ./src/helpers/LoanHelpers.js